import { createContext, FC, ReactNode, useContext, useState } from 'react';

interface LoadingContextType {
  loading: boolean;
  setLoading: (loading: boolean) => void;
  label: string;
  setLabel: (label: string) => void;
}

export const LoadingContext = createContext<LoadingContextType | undefined>(
  undefined
);

export const useLoading = () => {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }

  return context;
};

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider: FC<LoadingProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState('');

  return (
    <LoadingContext.Provider value={{ loading, setLoading, label, setLabel }}>
      {children}
    </LoadingContext.Provider>
  );
};
